const request = require('request');
const config = require('./config');

const get = (token, filters) => {
  return new Promise((resolve,reject) => {
    const f = (filters.filters !== '') ? ('&filters='+filters.filters) : '';
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/log'
        +'?idFornecedor='+filters.idFornecedor
        +'&linhaInicial='+filters.linhaInicial
        +'&qtdRegistro='+filters.qtdRegistro
        +f,
      method: 'GET'
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

const info = (token,ds) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/log',
      method: 'POST',
      body: JSON.stringify({descricao: ds, tipo: "I"})
    }, (err, res, body) => {
      if (err) console.error(err)
      resolve(body);
    });
  });
};

const warning = (token,ds) => {
  console.log('warning', ds)
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/log',
      method: 'POST',
      body: JSON.stringify({descricao: ds, tipo: "W"})
    }, (err, res, body) => {
      if (err) console.error(err)
      resolve(body);
    });
  });
};

const error = (token,ds) => {
  console.log('error', ds)
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/log',
      method: 'POST',
      body: JSON.stringify({descricao: ds, tipo: "E"})
    }, (err, res, body) => {
      if (err) console.error(err)
      resolve(body);
    });
  });
};

module.exports = {
  get: get,
  info: info,
  warning: warning,
  error: error
}